import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { moveXFocus, resetXFocus } from 'App/focus/actions'
import { logoutRequest } from 'App/auth/actions'
import { history } from 'store'
import { notEqual, userHasSubscription, userHasActiveSubscription } from 'utils'
import { StyledSection, StyledButton, StyledImg } from './Step4.style'
import pwa from 'img/pwa.png'

const isFocussed = ({ xFocus, xFocusId }) => xFocus === xFocusId

class Step4 extends Component {
  state = {
    yFocus: 0
  }

  componentDidMount() {
    const { resetXFocus } = this.props
    resetXFocus(1)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (isFocussed(this.props)) {
      const { focus } = nextProps
      const {
        focus: { moveLeft, moveUp, moveDown, pressEnter, pressBack },
        moveXFocus,
        logoutRequest
      } = this.props
      const { yFocus } = this.state
      notEqual(focus.moveLeft, moveLeft) && moveXFocus(-1)
      notEqual(focus.pressBack, pressBack) && history.goBack()
      notEqual(focus.pressEnter, pressEnter) && yFocus === 0 && logoutRequest()
      notEqual(focus.pressEnter, pressEnter) && yFocus === 1 && logoutRequest()
      notEqual(focus.moveUp, moveUp) &&
        yFocus !== 0 &&
        this.setState({ yFocus: 0 })
      notEqual(focus.moveDown, moveDown) &&
        yFocus === 0 &&
        this.setState({ yFocus: 1 })
    }
  }

  formatDate = date => <b>{moment(date).format('dddd, MMMM Do YYYY')}</b>

  render() {
    const { user } = this.props
    const { yFocus } = this.state
    const { formatDate } = this
    const { REACT_APP_BUILD_TYPE } = process.env
    const focussed = isFocussed(this.props)
    return (
      <StyledSection>
        <h2>{'Your Account'}</h2>
        <h3>{'Subscription'}</h3>
        {!user ? (
          <p>{'You are not logged in.'}</p>
        ) : userHasSubscription(user) && userHasActiveSubscription(user) ? (
          <p>
            {'Your subsciption is valid until:'} {formatDate(user.sub_expiry)}
          </p>
        ) : (
          <Fragment>
            <p>
              {'Your subsciption expired on:'} {formatDate(user.sub_expiry)}
            </p>
            <h3>{'Start your 7 day free trial via Amazon Payments:'}</h3>
            {REACT_APP_BUILD_TYPE === 'amazon' && (
              <StyledImg
                focussed={focussed && yFocus === 0}
                src={pwa}
                alt={'Pay with Amazon'}
              />
            )}
          </Fragment>
        )}
        {!!user && (
          <StyledButton focussed={focussed && yFocus === 1}>
            {'Log out'}
          </StyledButton>
        )}
      </StyledSection>
    )
  }
}

const mapStateToProps = ({ focus, user }) => ({ focus, user })

const connected = connect(
  mapStateToProps,
  { moveXFocus, resetXFocus, logoutRequest }
)(Step4)
export default connected
